import { useTheme } from '@mui/material/styles';
import { useFrontendConfig } from '@hooks/useFrontendConfig';

const PROMO_LEARN_MORE_URL_KEY = 'promo-learn-more-url';

export const usePromoLearnMoreUrl = (): string => {
  const theme = useTheme();
  const { data } = useFrontendConfig();
  return data?.[PROMO_LEARN_MORE_URL_KEY] ?? theme.novus.promoLearnMoreUrl;
};
